"use client";

import { c as _c } from "react/compiler-runtime";
import { readFragment } from "@opensea/graphql";
import { CardContentMedia, classNames, SkeletonBlock } from "@opensea/ui-kit";
import { useState } from "react";
import { ItemMedia } from "../../ItemMedia/ItemMedia";
import { ItemCardMediaFragment } from "./ItemCardMedia.fragment";
import { useAspectRatio } from "./ItemCardMediaAspectRatio";
import { ItemCardVideo } from "./ItemCardVideo";
const SIZE = 350;
export function ItemCardMedia(t0) {
  const $ = _c(35);
  let className;
  let itemKey;
  let mediaClassName;
  let rest;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      item: itemKey,
      className,
      mediaClassName,
      adjustAspectRatio: t1,
      surface: t2,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = itemKey;
    $[3] = mediaClassName;
    $[4] = rest;
    $[5] = t1;
    $[6] = t2;
  } else {
    className = $[1];
    itemKey = $[2];
    mediaClassName = $[3];
    rest = $[4];
    t1 = $[5];
    t2 = $[6];
  }
  const adjustAspectRatio = t1 === undefined ? false : t1;
  const surface = t2 === undefined ? "preview" : t2;
  let t3;
  if ($[7] !== itemKey) {
    t3 = readFragment(ItemCardMediaFragment, itemKey);
    $[7] = itemKey;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const item = t3;
  const title = `Item #${item.tokenId} Media`;
  const {
    aspectRatio,
    setAspectRatio
  } = useAspectRatio(item.id);
  const [isLoaded, setIsLoaded] = useState(false);
  let t4;
  if ($[9] !== className) {
    t4 = classNames("relative size-full bg-bg-additional-1", className);
    $[9] = className;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== adjustAspectRatio || $[12] !== aspectRatio) {
    t5 = adjustAspectRatio && {
      aspectRatio
    };
    $[11] = adjustAspectRatio;
    $[12] = aspectRatio;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== t5) {
    t6 = {
      ...t5
    };
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== isLoaded) {
    t7 = isLoaded ? null : <SkeletonBlock className="-z-10 absolute inset-0" />;
    $[16] = isLoaded;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== setAspectRatio) {
    t8 = (w, h) => {
      setAspectRatio(w, h);
    };
    $[18] = setAspectRatio;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  let t10;
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => {
      setIsLoaded(true);
    };
    t10 = {
      video: ItemCardVideo
    };
    $[20] = t10;
    $[21] = t9;
  } else {
    t10 = $[20];
    t9 = $[21];
  }
  let t11;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      audio: "primary"
    };
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== item || $[24] !== mediaClassName || $[25] !== rest || $[26] !== surface || $[27] !== t8 || $[28] !== title) {
    t12 = <ItemMedia className={mediaClassName} containerSize="100%" item={item} mediaSize={SIZE} onAspectRatioChange={t8} onLoad={t9} overrides={t10} surface={surface} surfaceOverrides={t11} title={title} {...rest} />;
    $[23] = item;
    $[24] = mediaClassName;
    $[25] = rest;
    $[26] = surface;
    $[27] = t8;
    $[28] = title;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12 || $[31] !== t4 || $[32] !== t6 || $[33] !== t7) {
    t13 = <CardContentMedia className={t4} style={t6}>{t7}{t12}</CardContentMedia>;
    $[30] = t12;
    $[31] = t4;
    $[32] = t6;
    $[33] = t7;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  return t13;
}